export const THEMES = Object.freeze([
  'primary',
  'positive',
  'negative',
  'support',
  'alert',
  'complementary',
  'disabled',
  'white',
  'canceled',
  'positive-2',
])

const cardThemeMap = Object.freeze({
  none: { noBorder: true },
  success: { green: true },
  error: { red: true },
  negative: { red: true },
  alert: { yellow: true },
  info: { blue: true },
  neutral: { gray: true },
  complementary: { complementary: true },
})

const legacyCardColorProps = [
  'red',
  'green',
  'yellow',
  'blue',
  'gray',
  'purple',
  'complementary'
]

export const resolveThemeBind = (row = {}) => {
  const theme = row?.theme
  const legacyProps = legacyCardColorProps.reduce((acc, key) => {
    if (row?.[key]) acc[key] = row[key]

    return acc
  }, {})

  if (theme && typeof theme === 'object') {
    return theme
  }

  if (typeof theme === 'string') {
    if (THEMES.includes(theme)) return { theme }

    if (cardThemeMap[theme]) return cardThemeMap[theme]
  }

  return legacyProps
}
